import { BotOff } from "lucide-react";
import React from "react";

type FallBackUiProps = {
  title?: string;
  description?: string;
  hideIcon?: boolean;
  icon?: React.ReactNode;
};

const FallBackUi: React.FC<FallBackUiProps> = ({
  title,
  description,
  icon,
  hideIcon,
}) => {
  return (
    <div
      className="flex items-center justify-center cursor-default"
      style={{
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
      }}
    >
      <div className="text-center mt-3 p-4 rounded-md flex flex-col justify-center text-muted-foreground items-center gap-1">
        {!hideIcon &&
          (icon ?? (
            <BotOff size={60} strokeWidth={1.9} className="text-lightGray" />
          ))}
        <span className="font-bold text-sm text-foreground">{title}</span>
        <span className="text-sm">{description}</span>
      </div>
    </div>
  );
};

export default FallBackUi;
